import { 
  ensureAuthorized, 
  ensureNotAuthorized 
} from '@/router/routerGuard';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);
const title = 'SBS';

const routes: Array<RouteConfig> = [
  {
    path: '/report-manager',
    name: 'home',
    meta: {
      title: `${title} - Beranda`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Home/HomeView.vue'),
  },
  {
    path: '/report-manager/change-password',
    name: 'change-password',
    meta: {
      title: `${title} - Ubah sandi`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Account/ChangePasswordView.vue')
  },
  {
    path: '/report-manager/attendence-report',
    name: 'attendence-report',
    meta: {
      title: `${title} - Laporan Ringkas Presensi`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/AttendenceReportView.vue')
  },
  {
    path: '/report-manager/overtime-report',
    name: 'overtime-report',
    meta: {
      title: `${title} - Laporan Lembur`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/OvertimeReportView.vue')
  },
  {
    path: '/report-manager/stock-report',
    name: 'stock-report',
    meta: {
      title: `${title} - Laporan Stok`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/StockReportView.vue')
  },
  {
    path: '/report-manager/transaction-report',
    name: 'transaction-report',
    meta: {
      title: `${title} - Laporan Transaksi`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/TransactionReportView.vue')
  },
  {
    path: '/report-manager/transaction-summary-report',
    name: 'transaction-summary-report',
    meta: {
      title: `${title} - Laporan Ringkas Transaksi`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/TransactionSummaryReportView.vue')
  },
  {
    path: '/report-manager/login',
    name: 'login',
    meta: {
      title: `${title} - Masuk`
    },
    beforeEnter: ensureNotAuthorized,
    component: () => import('@/views/Login/LoginView.vue')
  },
  {
    path: '/report-manager/fnb-report',
    name: 'fnb-report',
    meta: {
      title: `${title} - Laporan FnB`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/FnbReportView.vue')
  },
  {
    path: '/report-manager/food-and-drink-return-report',
    name: 'food-and-drink-return-report',
    meta: {
      title: `${title} - Laporan Pengembalian FnB`
    },
    beforeEnter: ensureAuthorized,
    component: () => import('@/views/Reports/FoodAndDrinkReturnReportView.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta?.title ?? '';
  });
});

export default router;
